import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from "@mui/material";

// Generic Select wrapper for MUI with optional placeholder and label shrink control
const Select = ({
  xs = 12,
  sm,
  md,
  lg,
  xl,
  name,
  label,
  datasource = [],
  columns = [],
  valuePath,
  value,
  onChange,
  readOnly = false,
  required = false,
  sx = {},
  displayEmpty = false,
  placeholder = '',
  shrinkLabel = false,
}) => {
  const displayField = columns[0];
  const labelId = `${name}-label`;
  const shouldShrink = shrinkLabel || (value !== undefined && value !== null && value !== '');

  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} sx={sx}>
      <FormControl
        fullWidth
        required={required}
        disabled={readOnly}
        variant="outlined"
      >
        <InputLabel id={labelId} shrink={shouldShrink}>{label}</InputLabel>
        <MuiSelect
          labelId={labelId}
          id={name}
          name={name}
          value={value ?? ""}
          onChange={(e) => onChange?.(e.target.value)}
          label={label}
          displayEmpty={displayEmpty}
          renderValue={(selected) => {
            if ((selected === undefined || selected === null || selected === '') && displayEmpty) {
              return <span style={{ color: 'rgba(0,0,0,0.38)' }}>{placeholder || ''}</span>;
            }
            const item = Array.isArray(datasource) ? datasource.find((x) => String(x[valuePath]) === String(selected)) : null;
            return item ? item[displayField] : selected;
          }}
        >
          {displayEmpty && (
            <MenuItem value="" disabled>
              {placeholder || ''}
            </MenuItem>
          )}
          {datasource.map((item, index) => (
            <MenuItem key={index} value={item[valuePath]}>
              {item[displayField]}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
    </Grid>
  );
};

export default Select;
